(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nixing-language-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('.nixing-language-switcher__form form');
      if (!form) return;

      const returnTo = form.elements.namedItem('return_to');
      if (!(returnTo instanceof HTMLInputElement)) return;

      returnTo.value = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
